import { render } from "./StudentMyTypingAssignments.vue?vue&type=template&id=2de45fce&scoped=true"
import script from "./StudentMyTypingAssignments.vue?vue&type=script&lang=js"
export * from "./StudentMyTypingAssignments.vue?vue&type=script&lang=js"

import "./StudentMyTypingAssignments.vue?vue&type=style&index=0&id=2de45fce&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de45fce"]])

export default __exports__